import styled from 'styled-components';
export const StrikethroughText = styled.span `
    text-decoration: line-through;
`;
//# sourceMappingURL=Strikethrough.styles.js.map